/* eslint-disable react/prop-types */
// import { PropTypes } from "prop-types";

import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import tw, { css, theme } from "twin.macro";
import { useMediaQuery } from "~hooks";
import Grid from "~components/styles/Grid.jsx";
import * as A from "~components/styles/Animations.jsx";
import * as T from "~components/styles/Typography.jsx";
import Image from "~components/Image.jsx";
import PortableText from "~components/PortableText.jsx";
import { lowerCaseNoSpaces } from "~utils/helpers";

const MapSection = () => {
  const { sanityMap } = useStaticQuery(graphql`
    query Map {
      sanityMap {
        textColor {
          title
        }
        backgroundColor {
          title
        }
        header
        subheader
        _rawBody
        image {
          altText
          asset {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
        }
        states {
          _key
          title
          image {
            asset {
              gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
            }
            altText
          }
          locations
        }
      }
    }
  `);

  const background = lowerCaseNoSpaces(sanityMap.backgroundColor.title);
  const font = lowerCaseNoSpaces(sanityMap.textColor.title);

  // todo: (med priority) move to helper function
  let backgroundColor = `white`;
  let fontColor = `black`;

  if (background && theme`colors`?.[background]) {
    backgroundColor = theme`colors`?.[background];
  }

  if (font && theme`colors`?.[font]) {
    fontColor = theme`colors`?.[font];
  }

  const { isDesktop } = useMediaQuery();

  const [selectedState, setSelectedState] = useState(null);

  return (
    <section
      css={[
        tw`relative block`,
        css`
          background: ${backgroundColor};
          color: ${fontColor};
        `
      ]}
    >
      <Grid _css={[tw`relative pt-12 md:pt-16 pb-12`]}>
        <header tw="col-start-1 md:col-start-4 col-span-24 md:col-span-18 relative text-center pb-12">
          <T.Head level="2" font="2">
            {sanityMap.header}
          </T.Head>
        </header>

        {!isDesktop && (
          <div tw="w-full col-span-full text-center mb-8">
            <T.Head level="3" font="4" _css={[tw`mb-4`]}>
              {sanityMap.subheader}
            </T.Head>

            <PortableText blocks={sanityMap._rawBody} _css={[tw``]} />
          </div>
        )}

        <figure tw="relative w-full col-span-full md:col-span-12 mb-8 md:mb-0">
          <Image image={sanityMap.image} _css={[tw`w-full`]} />
          {sanityMap.states.map((state) => {
            if (selectedState === state.title) {
              return (
                <Image
                  image={state.image}
                  _css={[tw`absolute  w-full left-0`]}
                />
              );
            }
          })}
        </figure>

        <article tw="relative w-full col-start-1 md:col-start-14 col-span-full md:col-span-9">
          {isDesktop && (
            <>
              <T.Head level="3" font="4" _css={[tw`mb-4`]}>
                {sanityMap.subheader}
              </T.Head>

              <PortableText blocks={sanityMap._rawBody} _css={[tw`mb-12`]} />
            </>
          )}

          <article>
            <header tw="relative w-full flex justify-between mb-12">
              {sanityMap.states.map((state) => {
                const key = `state-title-${state._key}`;

                return (
                  <button
                    type="button"
                    key={key}
                    onMouseEnter={() => {
                      setSelectedState(state.title);
                    }}
                    onClick={() => {
                      if (selectedState === state.title) {
                        setSelectedState(null);
                      } else {
                        setSelectedState(state.title);
                      }
                    }}
                  >
                    <T.Body
                      level="3"
                      font="1"
                      _css={[
                        selectedState &&
                          selectedState !== state.title &&
                          tw`opacity-50`
                      ]}
                    >
                      {state.title}
                    </T.Body>
                  </button>
                );
              })}
            </header>

            <ul tw="relative w-full flex flex-wrap md:pr-10">
              {sanityMap.states.map((state) => {
                if (selectedState === state.title) {
                  return state.locations.map((location) => {
                    const key = `sate-location-${location}`;
                    return (
                      <li
                        tw="w-1/2 md:w-1/3 mb-4 text-center md:text-left"
                        key={key}
                      >
                        <T.Body font="2">{location}</T.Body>
                      </li>
                    );
                  });
                }
              })}
            </ul>
          </article>
        </article>
      </Grid>
    </section>
  );
};

export default MapSection;
